import { useEffect } from 'react';
import { useMapContext } from 'entities/map';

import { MutableRefObject } from 'react';
import { MapInfoWindowProps } from '../ui/MapInfoWindow/MapInfoWindow';

export const useMapListenerToCloseInfoWindow = (
  infoWindowRef: MutableRefObject<any>,
  onClose: MapInfoWindowProps['onClose']
) => {
  const { addClickListener, removeClickListener } = useMapContext();

  useEffect(() => {
    const handleMarkersClick = ({ layerName }: any) => {
      if (layerName !== 'drivers') {
        if(onClose) {
          onClose();
        }

        if (infoWindowRef.current) {
          infoWindowRef.current.hide();
        }
      }
    }

    addClickListener(handleMarkersClick);

    return () => {
      removeClickListener(handleMarkersClick);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
